import { render, staticRenderFns } from "./NovaProgramacaoRegiao.vue?vue&type=template&id=883ecee4"
import script from "./NovaProgramacaoRegiao.vue?vue&type=script&lang=js"
export * from "./NovaProgramacaoRegiao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports